export const userProfile = {
  phone: '138****8888',
  name: '王**',
  idCard: '440***********1234',
  memberLevel: 'VIP会员',
  verified: true,
  assetValue: 140418.0,
  goldPrice: 936.12,
  holdingGold: 150,
  orderCount: 3,
  processingCount: 2,
};

export const addresses = [
  {
    id: 1,
    name: '王先生',
    phone: '138****8888',
    region: '广东省 深圳市 南山区',
    detail: '科技园南区T3栋1201室',
    isDefault: true,
  },
  {
    id: 2,
    name: '王先生',
    phone: '138****8888',
    region: '广东省 广州市 天河区',
    detail: '珠江新城华夏路30号富力中心',
    isDefault: false,
  },
  {
    id: 3,
    name: '李女士',
    phone: '139****6666',
    region: '北京市 北京市 朝阳区',
    detail: '建国路88号SOHO现代城B座1502',
    isDefault: false,
  },
];

export const bankCards = [
  {
    id: 1,
    bank: '中国工商银行',
    cardType: '储蓄卡',
    cardNo: '6212 **** **** 8888',
    isDefault: true,
    theme: 'from-red-500 to-red-700',
  },
  {
    id: 2,
    bank: '招商银行',
    cardType: '储蓄卡',
    cardNo: '6225 **** **** 6666',
    isDefault: false,
    theme: 'from-brown-500 to-brown-800',
  },
  {
    id: 3,
    bank: '中国建设银行',
    cardType: '信用卡',
    cardNo: '6227 **** **** 3333',
    isDefault: false,
    theme: 'from-emerald-500 to-emerald-800',
  },
];

export const bankOptions = [
  '中国工商银行',
  '中国建设银行',
  '中国农业银行',
  '中国银行',
  '招商银行',
  '交通银行',
  '中信银行',
  '浦发银行',
  '兴业银行',
  '民生银行',
];

export const messages = [
  {
    id: 1,
    category: 'system',
    categoryLabel: '系统通知',
    title: '端午假期服务安排通知',
    content:
      '尊敬的客户，2025年端午节假期期间（6月8日-6月10日），CJJY预约服务及提货服务时间调整如下：预约锁价服务正常开放，实物提货及配送服务顺延至6月11日恢复。给您带来不便敬请谅解。',
    time: '2025-06-01 10:00',
    read: false,
  },
  {
    id: 2,
    category: 'trade',
    categoryLabel: '交易提醒',
    title: '预约订单支付成功',
    content:
      '您预约的 AU 999.9 投资金条 50g 已支付成功，金额 ¥46,806.00。我们将在1-2个工作日内安排实物交割，请留意履约进度通知。',
    time: '2025-08-10 14:35',
    read: false,
  },
  {
    id: 3,
    category: 'system',
    categoryLabel: '系统通知',
    title: '关于调整黄金预约服务费率的通知',
    content:
      '自2025年7月1日起，CJJY将对预约服务费率进行优化调整，黄金预约服务费调整为0.15%。感谢您一直以来的支持与信任。',
    time: '2025-06-10 09:00',
    read: true,
  },
  {
    id: 4,
    category: 'trade',
    categoryLabel: '交易提醒',
    title: '预约锁价成功提醒',
    content:
      '您已成功锁价 AU 999.9 投资金条 20g，锁价 ¥936.12/g，请在30分钟内完成支付，超时锁价将自动失效。',
    time: '2025-08-13 10:20',
    read: true,
  },
  {
    id: 5,
    category: 'system',
    categoryLabel: '系统通知',
    title: 'CJJY荣获"2025年度最佳贵金属服务平台"',
    content:
      '在2025中国贵金属行业峰会上，CJJY凭借卓越的服务品质和技术创新能力荣获年度最佳平台奖，感谢每一位客户的信任。',
    time: '2025-06-05 15:30',
    read: true,
  },
  {
    id: 6,
    category: 'trade',
    categoryLabel: '交易提醒',
    title: '实物交割完成通知',
    content:
      '您预约的 AU 999.9 投资金条 500g 已完成实物交割，一货一码溯源信息已同步至您的金库，请及时查收。',
    time: '2025-08-10 15:00',
    read: true,
  },
];

export const vaultItems = [
  {
    id: 'VAULT001',
    product: 'AU 999.9 投资金条 50g',
    code: 'JN202508100001',
    weight: 50,
    status: '存储中',
    statusCode: 'stored',
    storeDate: '2025-08-10',
    location: '深圳金库 · A区-12柜',
  },
  {
    id: 'VAULT002',
    product: 'AU 999.9 投资金条 500g',
    code: 'JN202508080002',
    weight: 500,
    status: '存储中',
    statusCode: 'stored',
    storeDate: '2025-08-08',
    location: '北京金库 · B区-03柜',
  },
  {
    id: 'VAULT003',
    product: 'AU 999.9 投资金条 100g',
    code: 'JN202508120003',
    weight: 100,
    status: '交割中',
    statusCode: 'delivering',
    storeDate: '2025-08-12',
    location: '上海金库 · C区-08柜',
  },
];

export const helpFaqs = [
  {
    id: 1,
    q: '如何预约锁价？',
    a: '进入「预约锁价」页面，选择您心仪的金条规格，填写购买数量后点击「立即锁价」，即可按当前金价锁定价格。锁价后30分钟内需完成支付，超时锁价将自动失效。',
  },
  {
    id: 2,
    q: '锁价后可以取消吗？',
    a: '锁价成功但未支付前，您可以随时取消预约，不收取任何费用。已支付完成的订单如需取消，请在履约前联系客服处理，我们将按服务条款为您办理。',
  },
  {
    id: 3,
    q: '实物黄金如何提货？',
    a: '完成支付后，您可选择「金库自提」或「快递配送」两种方式。金库自提需携带本人有效身份证件；配送则由顺丰、京东等合作物流全额保价运输。',
  },
  {
    id: 4,
    q: '一货一码是什么？',
    a: '每一条金条都拥有独一无二的溯源编码，可通过扫码或输入编码查询该金条的生产批次、成色、重量及流转记录，确保实物真实可靠。',
  },
  {
    id: 5,
    q: '如何申请提现或兑换？',
    a: '在「我的金库」中，您可以选择持有的黄金进行兑换或出售，平台将按实时金价为您结算至绑定银行卡，资金一般在1-3个工作日内到账。',
  },
  {
    id: 6,
    q: '忘记登录密码怎么办？',
    a: '在登录页面点击「忘记密码」，通过手机验证码验证身份后即可重置密码。如手机号已停用，请联系在线客服协助处理。',
  },
];